import React from "react";
import './Subscription.scss';

export const sellerPlan = {
  name: 'Freeby',
  description: '',
  price: 0,
  period: 'month',
  features: [
    {
      section: 'Marketplace sales fee',
      items: [
        { text: 'Your existing customers', value: '0%' },
        { text: 'Customers through Tyrrst', value: '20%' },
      ],
    },
    {
      section: 'Payment',
      items: [
        { text: 'Accelerated payment (5 days)', value: '2%' },
        { text: '30 day payment', value: '0%' },
      ],
    },
  ],
  buttonText: 'Sign me up',
};

export const buyerPlan = {
  name: 'Freeby',
  description: '',
  price: 0,
  period: 'month',
  features: [
    {
      section: 'Marketplace',
      items: [
        { text: 'Search products across many brands' },
        { text: 'Buy multiple brands on a single invoice' },
        { text: 'Free shipment over Euro 300' },
        { text: 'Directly message brands' },
        { text: 'Tender for special needs' },
        { text: 'Collect Tyrrst Membership points' },
        { text: 'Save 5%, 8%, 10% or more' },
      ],
    },
    {
      section: 'Payment',
      items: [
        { text: 'Financing up to 90 days' },
      ],
    },
  ],
  buttonText: 'Sign me up',
};

const SUBSCRIPTION_DESCRIPTIONS = {
  seller: '',
  buyer: '',
};

const HEADLINE = 'Choose your subscription';
const SUBHEAD = 'We currently offer one membership plan – FREEBY! This gives you access to the Tyrrst marketplace and puts you in contact with brands from across the globe!';

const Subscription = ({ selected = 'seller', onSignUpClick }) => {
  const plan = selected === 'buyer' ? buyerPlan : sellerPlan;
  return (
    <div className="SubscriptionPage__container">
      <h1 className="SubscriptionPage__title">{HEADLINE}</h1>
      <p className="SubscriptionPage__desc">{SUBHEAD}</p>
      <div className="SubscriptionCard">
        <div className="SubscriptionCard__header">
          <span className="SubscriptionCard__badge">{plan.name}</span>
          <div className="SubscriptionCard__price">
            <span className="SubscriptionCard__price-main">€{plan.price}.00</span>
            <span className="SubscriptionCard__price-period">/{plan.period}</span>
          </div>
        </div>
        <div className="SubscriptionCard__features">
          {plan.features.map((feature, idx) => (
            <div className="SubscriptionCard__section" key={idx}>
              <div className="SubscriptionCard__section-title">{feature.section}</div>
              <ul>
                {feature.items.map((item, i) => (
                  <li key={i}>
                    {item.text} {item.value && <span className="SubscriptionCard__feature-value">{item.value}</span>}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <button className="SubscriptionCard__button SubscriptionCard__button--selected" onClick={onSignUpClick} type="button">
          {plan.buttonText}
        </button>
      </div>
    </div>
  );
};

export default Subscription;
